module.exports = __webpack_public_path__ + "static/media/af.008dc322.svg";